import { Component, Input } from '@angular/core';

import { ApiService }     from '../../api/api.service';
import { SessionService } from '../../sessions/session.service';

@Component({
  selector   : 'wor-admin-reports-system-error-logs',
  template: require('./admin-reports.system-error-logs.component.html')
})
export class AdminReportSystemErrorLogsComponent {
  @Input() companyId : string;

  beginDate = '*';
  endDate   = '*';

  constructor (
    private apiService    : ApiService,
    private sessionService: SessionService
  ) {}

  print ( type : 'csv' | 'pdf' = 'pdf' ) : void {
    const url = `${
        this.apiService.getEndpoint()
      }/reports/jasper_system_error_logs/${
        type
      }/${
        this.companyId || this.sessionService.company().id
      }/${
        this.beginDate
      }/${
        this.endDate
      }${
        type === 'pdf'
          ? '.pdf'
          : ''
      }`;

    window.open(url, '_blank');
  }
}
